import type {
  ApiContext,
  ApiNotAuthorized,
  CardStateRefused,
  InvalidFormField,
  NewSealedProduct,
  SealedProduct,
  SealedProductListFilter,
  SealedProductNotFound,
  SealedProductPatch,
  SealedStockUpdate,
  StockLevel,
  StoreNotFound,
  StoreRoleForbidden,
} from "@hobbyshopify/backend-client";
import type { AsyncResult } from "operation-result.js";
import type { AuthHandler } from "trunk.js";
import type { BackendApi } from "./api";

type Api = { client: BackendApi; authHandler: AuthHandler<ApiContext> };

export function loadSealedProducts(
  o: Api & { shopId: string; filter?: SealedProductListFilter; search?: string },
): AsyncResult<SealedProduct[], ApiNotAuthorized | StoreNotFound> {
  return o.authHandler.callApi((ctx) => o.client.sealed.list(ctx, o.shopId, { filter: o.filter, search: o.search }));
}

export function createSealedProduct(
  o: Api & { shopId: string; product: NewSealedProduct },
): AsyncResult<SealedProduct, ApiNotAuthorized | StoreNotFound | StoreRoleForbidden | InvalidFormField> {
  return o.authHandler.callApi((ctx) => o.client.sealed.create(ctx, o.shopId, o.product));
}

export function updateSealedProduct(
  o: Api & { shopId: string; sealedProductId: string; patch: SealedProductPatch },
): AsyncResult<
  SealedProduct,
  ApiNotAuthorized | StoreNotFound | StoreRoleForbidden | SealedProductNotFound | InvalidFormField
> {
  return o.authHandler.callApi((ctx) => o.client.sealed.update(ctx, o.shopId, o.sealedProductId, o.patch));
}

export function setSealedStock(
  o: Api & { shopId: string; sealedProductId: string; change: SealedStockUpdate },
): AsyncResult<
  StockLevel,
  ApiNotAuthorized | StoreNotFound | StoreRoleForbidden | SealedProductNotFound | CardStateRefused | InvalidFormField
> {
  return o.authHandler.callApi((ctx) => o.client.sealed.setStock(ctx, o.shopId, o.sealedProductId, o.change));
}

export function archiveSealedProduct(
  o: Api & { shopId: string; sealedProductId: string },
): AsyncResult<void, ApiNotAuthorized | StoreNotFound | StoreRoleForbidden | SealedProductNotFound | CardStateRefused> {
  return o.authHandler.callApi((ctx) => o.client.sealed.archive(ctx, o.shopId, o.sealedProductId));
}
